// extracted by mini-css-extract-plugin
module.exports = {"notifications":"Notifications_notifications__o50d-","circle":"Notifications_circle__2Ye73","circleWrapper":"Notifications_circleWrapper__3DmE3"};